import { useState } from "react";
import { CircleCheck, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { api, errMessage } from "@/lib/api";

export const CompleteButton = ({ id, onDone, testId = "take5-complete-button", className = "" }) => {
  const [busy, setBusy] = useState(false);
  const complete = async () => {
    setBusy(true);
    try {
      const r = await api.post(`/take5s/${id}/complete`);
      toast.success("Tâche déclarée terminée.");
      onDone(r.data);
    } catch (e) { toast.error(errMessage(e)); } finally { setBusy(false); }
  };
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button data-testid={testId} disabled={busy} className={`${className} bg-emerald-600 text-white hover:bg-emerald-500`}>
          {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <CircleCheck className="mr-2 h-4 w-4" />} Tâche terminée
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent data-testid={`${testId}-dialog`}>
        <AlertDialogHeader>
          <AlertDialogTitle>Déclarer la tâche terminée ?</AlertDialogTitle>
          <AlertDialogDescription>Le Take 5 sera clôturé avec l'heure actuelle du serveur. Il ne pourra plus être réévalué.</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid={`${testId}-cancel`}>Annuler</AlertDialogCancel>
          <AlertDialogAction data-testid={`${testId}-confirm`} onClick={complete}>Confirmer</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
